// extracted by mini-css-extract-plugin
export default {"siderMenu":"Sidebar_siderMenu__9Fx2p"};